import { saveRecord } from './scoreStore'
import ScoreModal from './ScoreModal.vue'

/**
 * 舒尔特方格成绩弹窗 mixin
 * 使用方需在 data 中提供 modeKey 与 modeName，并在完成时调用 schulteFinish()
 */
export default {
  components: { ScoreModal },
  data () {
    return {
      showResult: false,
      resultRecords: [],
      resultPercentile: 100,
      resultFirst: true
    }
  },
  computed: {
    latest5 () {
      // 最新 5 条，倒序（最新在前）
      return this.resultRecords.slice(-5).slice().reverse()
    }
  },
  methods: {
    schulteFinish () {
      const { records, percentile, first } = saveRecord(this.modeKey, this.time)
      this.resultRecords = records
      this.resultPercentile = percentile
      this.resultFirst = first
      this.showResult = true
    },
    closeResult () {
      this.showResult = false
    }
  }
}
